/**
 * @desc 保存或更新
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.BizSecondaryAdminConfigRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bizSecondaryAdminConfig/saveOrUpdate`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
